<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc1"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc1"><a href="#/Part1#P1">P<span class="small">ART</span> I. B<span class="small">LOODSHED AT THE</span> B<span class="small">ORDER</span></a></p>
<p class="toc1"><a href="#/Part2#P2">P<span class="small">ART</span> II. T<span class="small">HE</span> B<span class="small">EGINNING</span> R<span class="small">OOTS OF</span> R<span class="small">OUTE</span> 66</a></p>
<p class="toc"><a href="#/Chapter1#C1">Chapter 1. Some Didn’t Get Their Kicks on Route 66</a></p>
<p class="toc1"><a href="#/Part3#P3">P<span class="small">ART</span> III. M<span class="small">URDER AND</span> C<span class="small">RIME ON</span> O<span class="small">KLAHOMA</span>’<span class="small">S</span> R<span class="small">OUTE</span> 66</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">Chapter 2. The Bandit Who Wouldn’t Give Up</span></p>
<p class="toc1"><span href="#/Part4#P4" title="Link target outside of Sample">P<span class="small">ART</span> IV. T<span class="small">HE</span> T<span class="small">OWNS AND</span> C<span class="small">ITIES</span><span class="small">ALONG</span> O<span class="small">KLAHOMA</span> R<span class="small">OUTE</span> 66</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">Chapter 3. Miami</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">Chapter 4. Vinita</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">Chapter 5. Claremore</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">Chapter 6. Tulsa</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">Chapter 7. Sapulpa</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">Chapter 8. Kellyville</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">Chapter 9. Bristow</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10. Stroud: The Hell-Raising Town</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">Chapter 11. Chandler</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">Chapter 12. Edmond</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">Chapter 13. Oklahoma City</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">Chapter 14. Bethany</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">Chapter 15. Yukon</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">Chapter 16. El Reno</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">Chapter 17. Clinton</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">Chapter 18. Elk City</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">Chapter 19. Other Notable Stops along the Way</span></p>
<p class="toc1"><span href="#/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?ac5661fc